// extracted by mini-css-extract-plugin
export default {"Section":"Events_Section__B7N4x","Content":"Events_Content__gC2km","onLoad":"Events_onLoad__JURyd","EventsContainer":"Events_EventsContainer__shvD2"};